import React, { memo, useCallback, useContext } from 'react'

import {
  AIGenerated, Community, ImageAI, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, func } from 'prop-types'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import {
  importCommunityGalleryPanel,
} from 'Pods/ThreeDStudio/Components/LazyCommunityGalleryPanel/LazyCommunityGalleryPanel'
import { STUDIO_PATH } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'
import { clearModelSettings } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

import CommunityNav from './Components/CommunityNav/CommunityNav'
import NavItem from './Components/NavItem/NavItem'

function LinkNav({ isOpen = true, onNavigate }) {
  const t = useTranslation()
  const location = useLocation()
  const { twoDImagesIdeationFlowEnabled } = useContext(ThreeDStudioPageContext)
  const pathname = location?.pathname ?? ''

  // An opened model belongs to the generator that made it, not to the gallery it was
  // opened from, so only the bare 3D gallery path lights up Community. A community image
  // opens in a modal over the image gallery, so its URL keeps Community > Images lit.
  const isGenerateActive = pathname === STUDIO_PATH.GENERATE
    || pathname.startsWith(`${STUDIO_PATH.COMMUNITY_THREE_D_MODELS}/`)
  const isImageGeneratorActive = pathname === STUDIO_PATH.IMAGE_GENERATOR
    || pathname.startsWith(`${STUDIO_PATH.IMAGE_GENERATOR}/`)
  const isThreeDModelsActive = pathname === STUDIO_PATH.COMMUNITY_THREE_D_MODELS
  const isImagesActive = pathname === STUDIO_PATH.COMMUNITY_IMAGES
    || pathname.startsWith(`${STUDIO_PATH.COMMUNITY_IMAGES}/`)

  const handleGenerateClick = useCallback(() => {
    clearModelSettings()
    onNavigate()
  }, [onNavigate])

  return (
    <div className={classnames('link-nav', !isOpen && 'link-nav--collapsed')}>
      <NavItem
        to={STUDIO_PATH.GENERATE}
        label={t('sidebar.linkNav.generate')}
        icon={AIGenerated}
        isActive={isGenerateActive}
        isOpen={isOpen}
        tooltipId="link-nav-generate-tooltip"
        onClick={handleGenerateClick}
      />
      {twoDImagesIdeationFlowEnabled ? (
        <>
          <NavItem
            to={STUDIO_PATH.IMAGE_GENERATOR}
            label={t('sidebar.linkNav.imageGenerator')}
            icon={ImageAI}
            isActive={isImageGeneratorActive}
            isOpen={isOpen}
            tooltipId="link-nav-image-generator-tooltip"
            onClick={onNavigate}
          />
          <CommunityNav
            isOpen={isOpen}
            isThreeDModelsActive={isThreeDModelsActive}
            isImagesActive={isImagesActive}
            onNavigate={onNavigate}
          />
        </>
      ) : (
        <NavItem
          to={STUDIO_PATH.COMMUNITY_THREE_D_MODELS}
          label={t('sidebar.linkNav.communityGallery')}
          icon={Community}
          isActive={isThreeDModelsActive}
          isOpen={isOpen}
          tooltipId="link-nav-gallery-tooltip"
          onClick={onNavigate}
          onMouseEnter={importCommunityGalleryPanel}
          onFocus={importCommunityGalleryPanel}
        />
      )}
    </div>
  )
}

LinkNav.propTypes = {
  isOpen: bool,
  onNavigate: func.isRequired,
}

export default memo(LinkNav)
